import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox } from '@/_components';

import { useGetBrandsMutation } from '../apis';
import type { BrandQueryLinkerSchema } from '../schemas';

export function BrandsAsyncMultiSelect(props: FormAsyncComboboxProps<BrandQueryLinkerSchema, true>) {
  return (
    <FormAsyncCombobox
      {...props}
      isMulti
      showBorder
      itemToString={(item) => item.name}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      getMultiValueLabel={(item) => item.name}
      useApi={useGetBrandsMutation}
    />
  );
}
